<template>
    <transition :name="transitionName">
        <div
            class="tab-pane"
            v-show="active"
            role="tabpanel"
            :tab="name"
        >
            <slot></slot>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'TabPane',
        inject: {
            rootTabs: {
                from: 'rootTabs',
                default() {
                    return this.$parent;
                },
            },
        },
        props: {
            label: {
                type: String,
            },
            name: {
                type: String,
            },
            disabled: {
                type: Boolean,
            }
        },
        computed: {
            active() {
                return this.rootTabs.currentName === this.name;
            },
            transitionName() {
                return this.rootTabs.prevIndex > this.rootTabs.currentIndex ? 'tab-slide-right' : 'tab-slide-left';
            },
        },
        watch: {
            label() {
                this.rootTabs.$forceUpdate();
            },
            disabled() {
                this.rootTabs.$forceUpdate();
            },
        },
        created() {
            this.rootTabs.addPane(this);
        },
        destroyed() {
            this.rootTabs.removePane(this);
        }
    }
</script>

<style lang="scss" scoped>
    .tab-pane {
        position: relative;
        width: 100%;
        // transform: translateZ(0);
    }
    .tab-slide-left,
    .tab-slide-right {
        &-enter {
            opacity: 0.01;
        }
        &-enter-active {
            transition: all 300ms;
        }
        &-leave-active {
            position: absolute;
            top: 0;
            transition: all 300ms;
        }
        &-leave-to {
            opacity: 0.01;
        }
    }
    .tab-slide-left {
        &-enter {
            transform: translateX(100%);
        }
        &-leave-to {
            transform: translateX(-100%);
        }
    }
    .tab-slide-right {
        &-enter {
            transform: translateX(-100%);
        }
        &-leave-to {
            transform: translateX(100%);
        }
    }
</style>